export const colors = {
  green: '#4CAF50',
  red: '#dc3545',
  blue: '#008CBA',
};
